import { useState as nt, useRef as it, useCallback as Oe } from "react";
var ot = typeof global == "object" && global && global.Object === Object && global;
const Ge = ot;
var st = typeof self == "object" && self && self.Object === Object && self, ct = Ge || st || Function("return this")();
const T = ct;
var ft = T.Symbol;
const W = ft;
var Ve = Object.prototype, ut = Ve.hasOwnProperty, lt = Ve.toString, M = W ? W.toStringTag : void 0;
function gt(e) {
  var t = ut.call(e, M), r = e[M];
  try {
    e[M] = void 0;
    var a = !0;
  } catch (i) {
  }
  var n = lt.call(e);
  return a && (t ? e[M] = r : delete e[M]), n;
}
var ht = Object.prototype, pt = ht.toString;
function bt(e) {
  return pt.call(e);
}
var vt = "[object Null]", mt = "[object Undefined]", Ae = W ? W.toStringTag : void 0;
function C(e) {
  return e == null ? e === void 0 ? mt : vt : Ae && Ae in Object(e) ? gt(e) : bt(e);
}
function ae(e) {
  return e != null && typeof e == "object";
}
var yt = Array.isArray;
const dt = yt;
function Ne(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var wt = "[object AsyncFunction]", Tt = "[object Function]", jt = "[object GeneratorFunction]", xt = "[object Proxy]";
function ne(e) {
  if (!Ne(e))
    return !1;
  var t = C(e);
  return t == Tt || t == jt || t == wt || t == xt;
}
var Ot = T["__core-js_shared__"];
const K = Ot;
var Be = function() {
  var e = /[^.]+$/.exec(K && K.keys && K.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function At(e) {
  return !!Be && Be in e;
}
var Bt = Function.prototype, Pt = Bt.toString;
function O(e) {
  if (e != null) {
    try {
      return Pt.call(e);
    } catch (t) {
    }
    try {
      return e + "";
    } catch (t) {
    }
  }
  return "";
}
var Et = /[\\^$.*+?()[\]{}|]/g, St = /^\[object .+?Constructor\]$/, $t = Function.prototype, Ut = Object.prototype, Rt = $t.toString, Ft = Ut.hasOwnProperty, Mt = RegExp(
  "^" + Rt.call(Ft).replace(Et, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Dt(e) {
  if (!Ne(e) || At(e))
    return !1;
  var t = ne(e) ? Mt : St;
  return t.test(O(e));
}
function kt(e, t) {
  return e == null ? void 0 : e[t];
}
function I(e, t) {
  var r = kt(e, t);
  return Dt(r) ? r : void 0;
}
var Ct = I(T, "WeakMap");
const q = Ct;
var It = 9007199254740991;
function Xe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= It;
}
function Lt(e) {
  return e != null && Xe(e.length) && !ne(e);
}
var Wt = Object.prototype;
function _e(e) {
  var t = e && e.constructor, r = typeof t == "function" && t.prototype || Wt;
  return e === r;
}
var Ht = "[object Arguments]";
function Pe(e) {
  return ae(e) && C(e) == Ht;
}
var Ke = Object.prototype, zt = Ke.hasOwnProperty, Gt = Ke.propertyIsEnumerable, Vt = Pe(function() {
  return arguments;
}()) ? Pe : function(e) {
  return ae(e) && zt.call(e, "callee") && !Gt.call(e, "callee");
};
const Nt = Vt;
function Xt() {
  return !1;
}
var Ye = typeof exports == "object" && exports && !exports.nodeType && exports, Ee = Ye && typeof module == "object" && module && !module.nodeType && module, _t = Ee && Ee.exports === Ye, Se = _t ? T.Buffer : void 0, Kt = Se ? Se.isBuffer : void 0, Yt = Kt || Xt;
const Jt = Yt;
var qt = "[object Arguments]", Qt = "[object Array]", Zt = "[object Boolean]", er = "[object Date]", tr = "[object Error]", rr = "[object Function]", ar = "[object Map]", nr = "[object Number]", ir = "[object Object]", or = "[object RegExp]", sr = "[object Set]", cr = "[object String]", fr = "[object WeakMap]", ur = "[object ArrayBuffer]", lr = "[object DataView]", gr = "[object Float32Array]", hr = "[object Float64Array]", pr = "[object Int8Array]", br = "[object Int16Array]", vr = "[object Int32Array]", mr = "[object Uint8Array]", yr = "[object Uint8ClampedArray]", dr = "[object Uint16Array]", wr = "[object Uint32Array]", l = {};
l[gr] = l[hr] = l[pr] = l[br] = l[vr] = l[mr] = l[yr] = l[dr] = l[wr] = !0;
l[qt] = l[Qt] = l[ur] = l[Zt] = l[lr] = l[er] = l[tr] = l[rr] = l[ar] = l[nr] = l[ir] = l[or] = l[sr] = l[cr] = l[fr] = !1;
function Tr(e) {
  return ae(e) && Xe(e.length) && !!l[C(e)];
}
function jr(e) {
  return function(t) {
    return e(t);
  };
}
var Je = typeof exports == "object" && exports && !exports.nodeType && exports, k = Je && typeof module == "object" && module && !module.nodeType && module, xr = k && k.exports === Je, Y = xr && Ge.process, Or = function() {
  try {
    var e = k && k.require && k.require("util").types;
    return e || Y && Y.binding && Y.binding("util");
  } catch (t) {
  }
}();
const $e = Or;
var Ue = $e && $e.isTypedArray, Ar = Ue ? jr(Ue) : Tr;
const Br = Ar;
function Pr(e, t) {
  return function(r) {
    return e(t(r));
  };
}
var Er = Pr(Object.keys, Object);
const Sr = Er;
var $r = Object.prototype, Ur = $r.hasOwnProperty;
function Rr(e) {
  if (!_e(e))
    return Sr(e);
  var t = [];
  for (var r in Object(e))
    Ur.call(e, r) && r != "constructor" && t.push(r);
  return t;
}
var Fr = I(T, "Map");
const Q = Fr;
var Mr = I(T, "DataView");
const Z = Mr;
var Dr = I(T, "Promise");
const ee = Dr;
var kr = I(T, "Set");
const te = kr;
var Re = "[object Map]", Cr = "[object Object]", Fe = "[object Promise]", Me = "[object Set]", De = "[object WeakMap]", ke = "[object DataView]", Ir = O(Z), Lr = O(Q), Wr = O(ee), Hr = O(te), zr = O(q), x = C;
(Z && x(new Z(new ArrayBuffer(1))) != ke || Q && x(new Q()) != Re || ee && x(ee.resolve()) != Fe || te && x(new te()) != Me || q && x(new q()) != De) && (x = function(e) {
  var t = C(e), r = t == Cr ? e.constructor : void 0, a = r ? O(r) : "";
  if (a)
    switch (a) {
      case Ir:
        return ke;
      case Lr:
        return Re;
      case Wr:
        return Fe;
      case Hr:
        return Me;
      case zr:
        return De;
    }
  return t;
});
const Gr = x;
var Vr = "[object Map]", Nr = "[object Set]", Xr = Object.prototype, _r = Xr.hasOwnProperty;
function ba(e) {
  if (e == null)
    return !0;
  if (Lt(e) && (dt(e) || typeof e == "string" || typeof e.splice == "function" || Jt(e) || Br(e) || Nt(e)))
    return !e.length;
  var t = Gr(e);
  if (t == Vr || t == Nr)
    return !e.size;
  if (_e(e))
    return !Rr(e).length;
  for (var r in e)
    if (_r.call(e, r))
      return !1;
  return !0;
}
function va(e) {
  const [t, r] = nt(e), a = it(t), n = Oe((u) => {
    ne(u) ? r((f) => {
      const s = u(f);
      return a.current = s, s;
    }) : (a.current = u, r(u));
  }, []), i = Oe(() => a.current, []);
  return [t, n, i];
}
/*!
 * Compressor.js v1.2.1
 * https://fengyuanchen.github.io/compressorjs
 *
 * Copyright 2018-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2023-02-28T14:09:41.732Z
 */
function Ce(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    t && (a = a.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), r.push.apply(r, a);
  }
  return r;
}
function L(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ce(Object(r), !0).forEach(function(a) {
      Jr(e, a, r[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Ce(Object(r)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(r, a));
    });
  }
  return e;
}
function Kr(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Ie(e, t) {
  for (var r = 0; r < t.length; r++) {
    var a = t[r];
    a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, qe(a.key), a);
  }
}
function Yr(e, t, r) {
  return t && Ie(e.prototype, t), r && Ie(e, r), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Jr(e, t, r) {
  return t = qe(t), t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}
function H() {
  return H = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, H.apply(this, arguments);
}
function qr(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var a = r.call(e, t || "default");
    if (typeof a != "object")
      return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qe(e) {
  var t = qr(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var Qe = { exports: {} };
(function(e) {
  typeof window != "undefined" && function(t) {
    var r = t.HTMLCanvasElement && t.HTMLCanvasElement.prototype, a = t.Blob && function() {
      try {
        return !!new Blob();
      } catch (s) {
        return !1;
      }
    }(), n = a && t.Uint8Array && function() {
      try {
        return new Blob([new Uint8Array(100)]).size === 100;
      } catch (s) {
        return !1;
      }
    }(), i = t.BlobBuilder || t.WebKitBlobBuilder || t.MozBlobBuilder || t.MSBlobBuilder, u = /^data:((.*?)(;charset=.*?)?)(;base64)?,/, f = (a || i) && t.atob && t.ArrayBuffer && t.Uint8Array && function(s) {
      var c, g, h, y, p, o, d, b, A;
      if (c = s.match(u), !c)
        throw new Error("invalid data URI");
      for (g = c[2] ? c[1] : "text/plain" + (c[3] || ";charset=US-ASCII"), h = !!c[4], y = s.slice(c[0].length), h ? p = atob(y) : p = decodeURIComponent(y), o = new ArrayBuffer(p.length), d = new Uint8Array(o), b = 0; b < p.length; b += 1)
        d[b] = p.charCodeAt(b);
      return a ? new Blob([n ? d : o], {
        type: g
      }) : (A = new i(), A.append(o), A.getBlob(g));
    };
    t.HTMLCanvasElement && !r.toBlob && (r.mozGetAsFile ? r.toBlob = function(s, c, g) {
      var h = this;
      setTimeout(function() {
        g && r.toDataURL && f ? s(f(h.toDataURL(c, g))) : s(h.mozGetAsFile("blob", c));
      });
    } : r.toDataURL && f && (r.msToBlob ? r.toBlob = function(s, c, g) {
      var h = this;
      setTimeout(function() {
        (c && c !== "image/png" || g) && r.toDataURL && f ? s(f(h.toDataURL(c, g))) : s(h.msToBlob(c));
      });
    } : r.toBlob = function(s, c, g) {
      var h = this;
      setTimeout(function() {
        s(f(h.toDataURL(c, g)));
      });
    })), e.exports ? e.exports = f : t.dataURLtoBlob = f;
  }(window);
})(Qe);
var Le = Qe.exports, Qr = function(t) {
  return typeof Blob == "undefined" ? !1 : t instanceof Blob || Object.prototype.toString.call(t) === "[object Blob]";
}, We = {
  /**
   * Indicates if output the original image instead of the compressed one
   * when the size of the compressed image is greater than the original one's
   * @type {boolean}
   */
  strict: !0,
  /**
   * Indicates if read the image's Exif Orientation information,
   * and then rotate or flip the image automatically.
   * @type {boolean}
   */
  checkOrientation: !0,
  /**
   * Indicates if retain the image's Exif information after compressed.
   * @type {boolean}
  */
  retainExif: !1,
  /**
   * The max width of the output image.
   * @type {number}
   */
  maxWidth: 1 / 0,
  /**
   * The max height of the output image.
   * @type {number}
   */
  maxHeight: 1 / 0,
  /**
   * The min width of the output image.
   * @type {number}
   */
  minWidth: 0,
  /**
   * The min height of the output image.
   * @type {number}
   */
  minHeight: 0,
  /**
   * The width of the output image.
   * If not specified, the natural width of the source image will be used.
   * @type {number}
   */
  width: void 0,
  /**
   * The height of the output image.
   * If not specified, the natural height of the source image will be used.
   * @type {number}
   */
  height: void 0,
  /**
   * Sets how the size of the image should be resized to the container
   * specified by the `width` and `height` options.
   * @type {string}
   */
  resize: "none",
  /**
   * The quality of the output image.
   * It must be a number between `0` and `1`,
   * and only available for `image/jpeg` and `image/webp` images.
   * Check out {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob canvas.toBlob}.
   * @type {number}
   */
  quality: 0.8,
  /**
   * The mime type of the output image.
   * By default, the original mime type of the source image file will be used.
   * @type {string}
   */
  mimeType: "auto",
  /**
   * Files whose file type is included in this list,
   * and whose file size exceeds the `convertSize` value will be converted to JPEGs.
   * @type {string｜Array}
   */
  convertTypes: ["image/png"],
  /**
   * PNG files over this size (5 MB by default) will be converted to JPEGs.
   * To disable this, just set the value to `Infinity`.
   * @type {number}
   */
  convertSize: 5e6,
  /**
   * The hook function to execute before draw the image into the canvas for compression.
   * @type {Function}
   * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
   * @param {HTMLCanvasElement} canvas - The canvas for compression.
   * @example
   * function (context, canvas) {
   *   context.fillStyle = '#fff';
   * }
   */
  beforeDraw: null,
  /**
   * The hook function to execute after drew the image into the canvas for compression.
   * @type {Function}
   * @param {CanvasRenderingContext2D} context - The 2d rendering context of the canvas.
   * @param {HTMLCanvasElement} canvas - The canvas for compression.
   * @example
   * function (context, canvas) {
   *   context.filter = 'grayscale(100%)';
   * }
   */
  drew: null,
  /**
   * The hook function to execute when success to compress the image.
   * @type {Function}
   * @param {File} file - The compressed image File object.
   * @example
   * function (file) {
   *   console.log(file);
   * }
   */
  success: null,
  /**
   * The hook function to execute when fail to compress the image.
   * @type {Function}
   * @param {Error} err - An Error object.
   * @example
   * function (err) {
   *   console.log(err.message);
   * }
   */
  error: null
}, Zr = typeof window != "undefined" && typeof window.document != "undefined", w = Zr ? window : {}, z = function(t) {
  return t > 0 && t < 1 / 0;
}, ea = Array.prototype.slice;
function ie(e) {
  return Array.from ? Array.from(e) : ea.call(e);
}
var ta = /^image\/.+$/;
function re(e) {
  return ta.test(e);
}
function ra(e) {
  var t = re(e) ? e.substr(6) : "";
  return t === "jpeg" && (t = "jpg"), ".".concat(t);
}
var Ze = String.fromCharCode;
function aa(e, t, r) {
  var a = "", n;
  for (r += t, n = t; n < r; n += 1)
    a += Ze(e.getUint8(n));
  return a;
}
var na = w.btoa;
function He(e, t) {
  for (var r = [], a = 8192, n = new Uint8Array(e); n.length > 0; )
    r.push(Ze.apply(null, ie(n.subarray(0, a)))), n = n.subarray(a);
  return "data:".concat(t, ";base64,").concat(na(r.join("")));
}
function ia(e) {
  var t = new DataView(e), r;
  try {
    var a, n, i;
    if (t.getUint8(0) === 255 && t.getUint8(1) === 216)
      for (var u = t.byteLength, f = 2; f + 1 < u; ) {
        if (t.getUint8(f) === 255 && t.getUint8(f + 1) === 225) {
          n = f;
          break;
        }
        f += 1;
      }
    if (n) {
      var s = n + 4, c = n + 10;
      if (aa(t, s, 4) === "Exif") {
        var g = t.getUint16(c);
        if (a = g === 18761, (a || g === 19789) && t.getUint16(c + 2, a) === 42) {
          var h = t.getUint32(c + 4, a);
          h >= 8 && (i = c + h);
        }
      }
    }
    if (i) {
      var y = t.getUint16(i, a), p, o;
      for (o = 0; o < y; o += 1)
        if (p = i + o * 12 + 2, t.getUint16(p, a) === 274) {
          p += 8, r = t.getUint16(p, a), t.setUint16(p, 1, a);
          break;
        }
    }
  } catch (d) {
    r = 1;
  }
  return r;
}
function oa(e) {
  var t = 0, r = 1, a = 1;
  switch (e) {
    case 2:
      r = -1;
      break;
    case 3:
      t = -180;
      break;
    case 4:
      a = -1;
      break;
    case 5:
      t = 90, a = -1;
      break;
    case 6:
      t = 90;
      break;
    case 7:
      t = 90, r = -1;
      break;
    case 8:
      t = -90;
      break;
  }
  return {
    rotate: t,
    scaleX: r,
    scaleY: a
  };
}
var sa = /\.\d*(?:0|9){12}\d*$/;
function ze(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1e11;
  return sa.test(e) ? Math.round(e * t) / t : e;
}
function D(e) {
  var t = e.aspectRatio, r = e.height, a = e.width, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none", i = z(a), u = z(r);
  if (i && u) {
    var f = r * t;
    (n === "contain" || n === "none") && f > a || n === "cover" && f < a ? r = a / t : a = r * t;
  } else
    i ? r = a / t : u && (a = r * t);
  return {
    width: a,
    height: r
  };
}
function ca(e) {
  for (var t = ie(new Uint8Array(e)), r = t.length, a = [], n = 0; n + 3 < r; ) {
    var i = t[n], u = t[n + 1];
    if (i === 255 && u === 218)
      break;
    if (i === 255 && u === 216)
      n += 2;
    else {
      var f = t[n + 2] * 256 + t[n + 3], s = n + f + 2, c = t.slice(n, s);
      a.push(c), n = s;
    }
  }
  return a.reduce(function(g, h) {
    return h[0] === 255 && h[1] === 225 ? g.concat(h) : g;
  }, []);
}
function fa(e, t) {
  var r = ie(new Uint8Array(e));
  if (r[2] !== 255 || r[3] !== 224)
    return e;
  var a = r[4] * 256 + r[5], n = [255, 216].concat(t, r.slice(4 + a));
  return new Uint8Array(n);
}
var ua = w.ArrayBuffer, J = w.FileReader, j = w.URL || w.webkitURL, la = /\.\w+$/, ga = w.Compressor, ma = /* @__PURE__ */ function() {
  function e(t, r) {
    Kr(this, e), this.file = t, this.exif = [], this.image = new Image(), this.options = L(L({}, We), r), this.aborted = !1, this.result = null, this.init();
  }
  return Yr(e, [{
    key: "init",
    value: function() {
      var r = this, a = this.file, n = this.options;
      if (!Qr(a)) {
        this.fail(new Error("The first argument must be a File or Blob object."));
        return;
      }
      var i = a.type;
      if (!re(i)) {
        this.fail(new Error("The first argument must be an image File or Blob object."));
        return;
      }
      if (!j || !J) {
        this.fail(new Error("The current browser does not support image compression."));
        return;
      }
      ua || (n.checkOrientation = !1, n.retainExif = !1);
      var u = i === "image/jpeg", f = u && n.checkOrientation, s = u && n.retainExif;
      if (j && !f && !s)
        this.load({
          url: j.createObjectURL(a)
        });
      else {
        var c = new J();
        this.reader = c, c.onload = function(g) {
          var h = g.target, y = h.result, p = {}, o = 1;
          f && (o = ia(y), o > 1 && H(p, oa(o))), s && (r.exif = ca(y)), f || s ? !j || o > 1 ? p.url = He(y, i) : p.url = j.createObjectURL(a) : p.url = y, r.load(p);
        }, c.onabort = function() {
          r.fail(new Error("Aborted to read the image with FileReader."));
        }, c.onerror = function() {
          r.fail(new Error("Failed to read the image with FileReader."));
        }, c.onloadend = function() {
          r.reader = null;
        }, f || s ? c.readAsArrayBuffer(a) : c.readAsDataURL(a);
      }
    }
  }, {
    key: "load",
    value: function(r) {
      var a = this, n = this.file, i = this.image;
      i.onload = function() {
        a.draw(L(L({}, r), {}, {
          naturalWidth: i.naturalWidth,
          naturalHeight: i.naturalHeight
        }));
      }, i.onabort = function() {
        a.fail(new Error("Aborted to load the image."));
      }, i.onerror = function() {
        a.fail(new Error("Failed to load the image."));
      }, w.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(w.navigator.userAgent) && (i.crossOrigin = "anonymous"), i.alt = n.name, i.src = r.url;
    }
  }, {
    key: "draw",
    value: function(r) {
      var a = this, n = r.naturalWidth, i = r.naturalHeight, u = r.rotate, f = u === void 0 ? 0 : u, s = r.scaleX, c = s === void 0 ? 1 : s, g = r.scaleY, h = g === void 0 ? 1 : g, y = this.file, p = this.image, o = this.options, d = document.createElement("canvas"), b = d.getContext("2d"), A = Math.abs(f) % 180 === 90, G = (o.resize === "contain" || o.resize === "cover") && z(o.width) && z(o.height), E = Math.max(o.maxWidth, 0) || 1 / 0, S = Math.max(o.maxHeight, 0) || 1 / 0, $ = Math.max(o.minWidth, 0) || 0, U = Math.max(o.minHeight, 0) || 0, B = n / i, v = o.width, m = o.height;
      if (A) {
        var oe = [S, E];
        E = oe[0], S = oe[1];
        var se = [U, $];
        $ = se[0], U = se[1];
        var ce = [m, v];
        v = ce[0], m = ce[1];
      }
      G && (B = v / m);
      var fe = D({
        aspectRatio: B,
        width: E,
        height: S
      }, "contain");
      E = fe.width, S = fe.height;
      var ue = D({
        aspectRatio: B,
        width: $,
        height: U
      }, "cover");
      if ($ = ue.width, U = ue.height, G) {
        var le = D({
          aspectRatio: B,
          width: v,
          height: m
        }, o.resize);
        v = le.width, m = le.height;
      } else {
        var ge = D({
          aspectRatio: B,
          width: v,
          height: m
        }), he = ge.width;
        v = he === void 0 ? n : he;
        var pe = ge.height;
        m = pe === void 0 ? i : pe;
      }
      v = Math.floor(ze(Math.min(Math.max(v, $), E))), m = Math.floor(ze(Math.min(Math.max(m, U), S)));
      var et = -v / 2, tt = -m / 2, rt = v, at = m, V = [];
      if (G) {
        var be = 0, ve = 0, N = n, X = i, me = D({
          aspectRatio: B,
          width: n,
          height: i
        }, {
          contain: "cover",
          cover: "contain"
        }[o.resize]);
        N = me.width, X = me.height, be = (n - N) / 2, ve = (i - X) / 2, V.push(be, ve, N, X);
      }
      if (V.push(et, tt, rt, at), A) {
        var ye = [m, v];
        v = ye[0], m = ye[1];
      }
      d.width = v, d.height = m, re(o.mimeType) || (o.mimeType = y.type);
      var de = "transparent";
      y.size > o.convertSize && o.convertTypes.indexOf(o.mimeType) >= 0 && (o.mimeType = "image/jpeg");
      var we = o.mimeType === "image/jpeg";
      if (we && (de = "#fff"), b.fillStyle = de, b.fillRect(0, 0, v, m), o.beforeDraw && o.beforeDraw.call(this, b, d), !this.aborted && (b.save(), b.translate(v / 2, m / 2), b.rotate(f * Math.PI / 180), b.scale(c, h), b.drawImage.apply(b, [p].concat(V)), b.restore(), o.drew && o.drew.call(this, b, d), !this.aborted)) {
        var Te = function(R) {
          if (!a.aborted) {
            var je = function(F) {
              return a.done({
                naturalWidth: n,
                naturalHeight: i,
                result: F
              });
            };
            if (R && we && o.retainExif && a.exif && a.exif.length > 0) {
              var xe = function(F) {
                return je(Le(He(fa(F, a.exif), o.mimeType)));
              };
              if (R.arrayBuffer)
                R.arrayBuffer().then(xe).catch(function() {
                  a.fail(new Error("Failed to read the compressed image with Blob.arrayBuffer()."));
                });
              else {
                var P = new J();
                a.reader = P, P.onload = function(_) {
                  var F = _.target;
                  xe(F.result);
                }, P.onabort = function() {
                  a.fail(new Error("Aborted to read the compressed image with FileReader."));
                }, P.onerror = function() {
                  a.fail(new Error("Failed to read the compressed image with FileReader."));
                }, P.onloadend = function() {
                  a.reader = null;
                }, P.readAsArrayBuffer(R);
              }
            } else
              je(R);
          }
        };
        d.toBlob ? d.toBlob(Te, o.mimeType, o.quality) : Te(Le(d.toDataURL(o.mimeType, o.quality)));
      }
    }
  }, {
    key: "done",
    value: function(r) {
      var a = r.naturalWidth, n = r.naturalHeight, i = r.result, u = this.file, f = this.image, s = this.options;
      if (j && f.src.indexOf("blob:") === 0 && j.revokeObjectURL(f.src), i)
        if (s.strict && !s.retainExif && i.size > u.size && s.mimeType === u.type && !(s.width > a || s.height > n || s.minWidth > a || s.minHeight > n || s.maxWidth < a || s.maxHeight < n))
          i = u;
        else {
          var c = /* @__PURE__ */ new Date();
          i.lastModified = c.getTime(), i.lastModifiedDate = c, i.name = u.name, i.name && i.type !== u.type && (i.name = i.name.replace(la, ra(i.type)));
        }
      else
        i = u;
      this.result = i, s.success && s.success.call(this, i);
    }
  }, {
    key: "fail",
    value: function(r) {
      var a = this.options;
      if (a.error)
        a.error.call(this, r);
      else
        throw r;
    }
  }, {
    key: "abort",
    value: function() {
      this.aborted || (this.aborted = !0, this.reader ? this.reader.abort() : this.image.complete ? this.fail(new Error("The compression process has been aborted.")) : (this.image.onload = null, this.image.onabort()));
    }
    /**
     * Get the no conflict compressor class.
     * @returns {Compressor} The compressor class.
     */
  }], [{
    key: "noConflict",
    value: function() {
      return window.Compressor = ga, e;
    }
    /**
     * Change the default options.
     * @param {Object} options - The new default options.
     */
  }, {
    key: "setDefaults",
    value: function(r) {
      H(We, r);
    }
  }]), e;
}();
export {
  ma as C,
  Q as M,
  W as S,
  ae as a,
  C as b,
  dt as c,
  Ne as d,
  Lt as e,
  Nt as f,
  I as g,
  Jt as h,
  ba as i,
  Br as j,
  Rr as k,
  Gr as l,
  Xe as m,
  jr as n,
  te as o,
  ne as p,
  T as r,
  va as u
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@bld/bld-libs/compressor.esm-9dfde4b1.js
// module id = 829
// module chunks = 0